document.addEventListener('DOMContentLoaded', () => {
  function getVideo(card) {
    const wrapper = card.querySelector('[data-card-hover-video]');
    return wrapper && wrapper.querySelector('video');
  }

  function getBentoVideo() {
    if (!window.matchMedia('(min-width: 750px)').matches) return null;
    const wrapper = document.querySelector('#product-grid > .grid__item:nth-child(3) [data-card-hover-video]');
    return wrapper && wrapper.querySelector('video');
  }

  function playBentoVideo() {
    const video = getBentoVideo();
    if (video) video.play().catch(() => {});
  }

  // Écouteurs délégués sur document (pointerover/pointerout bulle, contrairement
  // à mouseenter/mouseleave) : ça marche aussi pour les cartes réinjectées après
  // un filtre de collection, quand facets.js remplace #ProductGridContainer en
  // innerHTML — un écouteur posé une seule fois sur les cartes d'origine, lui,
  // ne suivrait pas les nouvelles cartes.
  document.addEventListener('pointerover', (e) => {
    const card = e.target.closest && e.target.closest('.card-wrapper');
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    const video = getVideo(card);
    if (!video) return;
    video.currentTime = 0;
    video.play().catch(() => {});
  });

  document.addEventListener('pointerout', (e) => {
    const card = e.target.closest && e.target.closest('.card-wrapper');
    if (card && !(e.relatedTarget && card.contains(e.relatedTarget))) {
      const video = getVideo(card);
      if (video) video.pause();
    }

    // La carte "bento" (3e produit de #product-grid) affiche son état survolé
    // en permanence : survoler une autre carte la met en pause au passage,
    // mais elle doit reprendre dès qu'on ne survole plus aucun produit.
    const stillOnACard = e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.card-wrapper');
    if (!stillOnACard) playBentoVideo();
  });

  playBentoVideo();

  // Un filtre de collection remplace #ProductGridContainer entièrement : la
  // carte bento est reconstruite avec une vidéo à l'arrêt, il faut donc la
  // relancer à chaque fois que la grille est réinjectée.
  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer && 'MutationObserver' in window) {
    new MutationObserver(playBentoVideo).observe(gridContainer, { childList: true, subtree: true });
  }
});
